import { useEffect, useRef, useState } from 'react';

export const useIntersectionObserver = (threshold = 0.5): [boolean, React.RefObject<HTMLDivElement>] => {
  const [isVisible, setIsVisible] = useState(false);
  const observerRef = useRef<IntersectionObserver | null>(null);
  const elementRef = useRef<HTMLDivElement>(null);
  let timeOut: NodeJS.Timeout | null = null,
    latestEntry: IntersectionObserverEntry | null = null;

  const onIntersection = (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
    if (Array.isArray(entries)) {
      entries?.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= threshold && !isVisible) {
          latestEntry = entry;
          clearTimeout(timeOut as NodeJS.Timeout);
          timeOut = setTimeout(() => {
            if (latestEntry?.isIntersecting && latestEntry?.intersectionRatio >= threshold) {
              setIsVisible(true);
              observer.disconnect();
            }
          }, 1000);
        } else clearTimeout(timeOut as NodeJS.Timeout);
      });
    }
  };

  useEffect(() => {
    if (elementRef?.current && observerRef.current === null) {
      observerRef.current = new IntersectionObserver(onIntersection, {
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0], // for smoother transition
      });
      observerRef.current?.observe(elementRef.current);
    }
  }, [elementRef, observerRef]);

  return [isVisible, elementRef];
};
